/* eslint-disable */
/**
 * Eye-Able Assist - visual tweaks + click-area fix for the main icon.
 *
 * The Eye-Able widget renders inside a shadow DOM, so our regular CSS cannot
 * reach it. We inject a small <style> into the shadow root once Eye-Able has
 * initialised to:
 *   1. Remove the drop-shadow filter on the icon (.mainIconSVG)
 *   2. Remove the white outer border of the standard icon
 *      (the 2nd <path> in the SVG; the white figure = 4th <path> stays white)
 *   3. Fix the oversized clickable area: the collapsed icon container is
 *      85x88px while the icon itself is only ~40-50px. That transparent dead
 *      space intercepts clicks/taps meant for elements behind it (worst on
 *      mobile). We make the collapsed container click-through and keep only
 *      the icon itself clickable. The `:not(.animeEyeAbleExtended)` scope
 *      ensures the expanded toolbar keeps all buttons fully clickable.
 *      (The open handler sits on the column and still fires because clicks on
 *      the icon bubble up to it.)
 *
 * Everything else about Eye-Able is standard and managed via the dashboard.
 */

function removeEyeAbleIconShadow() {
    const host = document.getElementById('eyeAble_container_ID');
    if (!host || !host.shadowRoot) return;

    // Avoid injecting the style more than once
    if (host.shadowRoot.getElementById('eyeAble_qredits_overrides')) return;

    const style = document.createElement('style');
    style.id = 'eyeAble_qredits_overrides';
    style.textContent =
        '.mainIconSVG { filter: none !important; }' +
        '.mainIconSVG path:nth-of-type(2) { fill: transparent !important; }' +
        '.animeEyeAble:not(.animeEyeAbleExtended) { pointer-events: none !important; }' +
        '.animeEyeAble:not(.animeEyeAbleExtended) .eyeAble_mainicon_container { pointer-events: auto !important; }';
    host.shadowRoot.appendChild(style);
}

// Eye-Able fires this event once the widget is fully initialised
document.addEventListener('eyeable:init_completed', removeEyeAbleIconShadow);

// In case Eye-Able already initialised before this script ran
removeEyeAbleIconShadow();
